import { useEffect, useState } from "react";

// MUI
import { GridRenderEditCellParams, useGridApiContext } from "@mui/x-data-grid-premium";

// Components
import TableInputValue from "@/Layouts/components/InputComponents/TableInputValue";

const isComputedCommission = (apiRef: { current: { getAllColumns: () => { field: string }[] } }, field = "") => {
	const { current } = apiRef || {};
	const isFieldDistinct = !["gross", "rate"].includes(field);
	const hasGross = current?.getAllColumns().some((col) => col.field === "gross");
	const hasRate = current?.getAllColumns().some((col) => col.field === "rate");
	return isFieldDistinct && (hasGross || hasRate);
};

export function CommissionEditCell(props: Readonly<GridRenderEditCellParams>) {
	const apiRef = useGridApiContext();
	const { id, field, hasFocus, error } = props;
	const [value, setValue] = useState(props.value ?? 0);
	const isComputed = isComputedCommission(apiRef, field);
	const isAddedCompensationRow = !isNaN(Number(props.row.rowIndex));

	useEffect(() => {
		setValue(props.value ?? 0);
	}, [props.value]);

	return (
		<TableInputValue
			isControlledApi={true}
			isRequiredOnChange={true}
			isNaNPrevented={true}
			isEditingMode={hasFocus}
			classes={"h-[25px] --table-input-value"}
			data={[
				{
					type: "Dollar",
					min: -1000000,
					max: 1000000,
					decimalsEditable: true,
					decimals: 2,
				},
			]}
			value={{
				value,
				input: "Dollar",
			}}
			error={error}
			onChange={(updated) => {
				setValue(updated);
			}}
			onBlur={async (updated) => {
				await apiRef.current.setEditCellValue({ id, field, value: updated, debounceMs: 200 });
				if (apiRef.current.state.editRows[id]) {
					apiRef.current.state.editRows[id][field].isDirty = false;
				}
			}}
			onClickInput={() => {
				apiRef.current.state.editRows[id][field].isDirty = true;
			}}
			disabled={isAddedCompensationRow && isComputed}
		/>
	);
}
